import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { LargeWrap } from "shared/wraps"
import TaskGroupingList from "./TaskGroupingList"
import TaskHeader from "./TaskHeader"

const TaskContent = ({ hiddenSidebar, toggleSidebar }) => (
  <LargeWrap className={clsx(!hiddenSidebar && "pl-80")}>
    <TaskHeader hiddenSidebar={hiddenSidebar} toggleSidebar={toggleSidebar} />
    <TaskGroupingList />
  </LargeWrap>
)

TaskContent.propTypes = {
  hiddenSidebar: types.bool.isRequired,
  toggleSidebar: types.func.isRequired,
}

export default TaskContent
